import React, { useEffect, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import { getSurgeon, getSurgeryList, } from "../services/EMRServices/emrServices";
import { Tooltip } from "@mui/material";
import { DeleteIcon, EditIcon } from "./EmrCommonAsset/Asset";
import CommonTransactionTable from "../../../common/components/CommonTable/CommonTransactionTable";
import OPDSurgeryModal from "./SurgeryModal";
import { useEMRGeneralContext } from "../newGeneralEmr/EMRContextGeneral";
import SearchDropdown from "../../../common/components/FormFields/searchDropdown";
import DropdownField from "../../../common/components/FormFields/DropdownField";
import CommonButton from "../../../common/components/Buttons/CommonButton";
import { useForm } from "react-hook-form";
import { UseCheckConsecutiveCharacters } from "../../../common/components/Custom Hooks/UseCheckConsecutiveCharacters";
import { warningAlert } from "../../../common/components/Toasts/CustomToasts";

export default function Surgery(props) {
  const { surgeryData, setSurgeryData, dataSurgery, setDataSurgery } = props;
  const [allSurgeryChipsList, setAllSurgeryChipsList] = useState([]);
  const [surgeryChipsList, setSurgeryChipsList] = useState([]);

  const [selectedSurgery, setSelectedSurgery] = useState(null);

  const [chipsCount, setChipsCount] = useState(5);
  const [checkDuplicate, setCheckDuplicate] = useState(false);
  const [selectedChips, setSelectedChips] = useState([]);
  const [openSurgeryModal, setOpenSurgeryModal] = useState(false);
  const [data, setData] = useState([]);
  const [edit, setEdit] = useState(false);
  const [row, setRow] = useState();
  const [index, setIndex] = useState();
  const [editOpen, setEditOpen] = useState(false);
  const [save, setSave] = useState(false);
  const [surgeryNameList, setSurgeryNameList] = useState();
  const [surgeonList, setSurgeonList] = useState();
  useEffect(() => {
    handleSurgeryChips();
  }, []);
  const {
    handleSubmit,
    reset,
    formState: { errors },
    control,
    register,
    setValue,
    watch,
  } = useForm({
    // resolver: yupResolver(validationSchema),
    // defaultValues: defaultValues,
  });
  //function to Get Diagnosis Chips
  const handleSurgeryChips = () => {
    getSurgeryList(props.patientVisitedDepartmentId, null)
      .then((response) => {
        setAllSurgeryChipsList(response.data.result);
        let chipsSurgery = [];
        response.data.result.map((item) => {
          // if (item.isCommon) {
          chipsSurgery.push(item);
          // }
        });

        setSurgeryChipsList(chipsSurgery);
      })
      .catch((err) => {
        console.log("Error");
      });
  };
  function deleteRow(index) {
    const newComplaintsData = [...surgeryData];
    newComplaintsData.splice(index, 1);
    setSurgeryData(newComplaintsData);
  }
  const renderAction = (row, index) => {
    return (
      <div className="flex gap-2">
        {/* <Tooltip title="Edit">
          <button
            type="button"
            onClick={() => {
              setRow(row);
              setEdit(true);
              setIndex(index);
              setEditOpen(true);
            }}
          >
            <EditIcon />
          </button>
        </Tooltip> */}

        <Tooltip title="Delete">
          <button
            type="button"
            onClick={() => {
              deleteRow(index);
            }}
          >
            <DeleteIcon />
          </button>
        </Tooltip>
      </div>
    );
  };

  useEffect(() => {
    if (save === true) {
      setSurgeryData([...dataSurgery]);
      setSave(false);
    }
  }, [save]);
  const handleChange = (e) => {
    if (e?.length > 0) {
      if (UseCheckConsecutiveCharacters(e)) {
        getSurgeryList(props.patientVisitedDepartmentId, e)
          .then((response) => {
            setSurgeryNameList(response.data.result);
          })
          .catch((res) => {
            console.log(res);
          });
      }
    } else if (e === "" || e === undefined || e === null) {
      setSurgeryNameList([]);
    }
  };
  const handleSurgeon = () => {
    getSurgeon()
      .then((response) => {
        // setValue("doctor", "");
        setSurgeonList(response.data.result);
      })
      .catch((response) => {
        console.log(response);
      });
  };
  useEffect(() => {
    handleSurgeon();
  }, []);
  let surgeryNameWatch = watch("surgeryName");
  let surgeonWatch = watch("surgeon");
  const handleSubmitSurgery = (data) => {
    // if (props.edit === false && editData === false) {
    let obj = {
      surgery: surgeryNameWatch?.label,
      surgeryId: surgeryNameWatch?.id,
      surgeon: surgeonWatch?.label,
      surgeonId: surgeonWatch?.id,
    };
    let temp = surgeryData.some(
      (item) => item.surgery === surgeryNameWatch?.label
    );
    if (temp === true) {
      warningAlert("Already Present Record..!");
      setValue("surgeryName", null);
      setValue("surgeon", null);
    } else {
      if (
        surgeryNameWatch !== null &&
        surgeryNameWatch?.label !== undefined
      ) {
        setSurgeryData((prevState) => [...prevState, obj]);
        setValue("surgeryName", null);
        setValue("surgeon", null);
      } else {
        warningAlert("Please Fill The Record");
      }
    }

    //   reset();
    // } else if (props.edit === true) {
    //   let updateobj = {
    //     surgery: surgeryNameWatch?.label,
    //     surgeryId: surgeryNameWatch?.id,
    //     surgeon: surgeonWatch?.label,
    //     surgeonId: surgeonWatch?.id,
    //   };
    //   let duplicateInd = surgeryData?.findIndex(
    //     (item, idx) =>
    //       item.surgery === surgeryNameWatch?.label && idx !== props.index
    //   );
    //   if (duplicateInd === -1) {
    //     let reqArr = [...surgeryData];
    //     console.log("reqArr", reqArr);
    //     reqArr.splice(props.index, 1, updateobj);
    //     setSurgeryData(reqArr);
    //     setDataSurgery(reqArr);
    //     props.setEditOpen(false);
    //     props.setEdit(false);
    //     setValue("surgeryName", null);
    //     setValue("surgeon", null);
    //   } else {
    //     warningAlert("Duplicate found, update not applied");
    //   }
    // } else if (editData === true) {
    //   let updateobj = {
    //     surgery: surgeryNameWatch?.label,
    //     surgeon: surgeonWatch?.label,
    //   };
    //   let duplicateInd = dataSurgery?.findIndex(
    //     (item, idx) => item.surgery === surgeryNameWatch?.label && idx !== index
    //   );
    //   if (duplicateInd === -1) {
    //     let reqArr = [...dataSurgery];
    //     console.log("reqArr", reqArr);
    //     reqArr.splice(index, 1, updateobj);
    //     setDataSurgery(reqArr);
    //     setEditData(false);
    //     setValue("surgeryName", null);
    //     setValue("surgeon", null);
    //   } else {
    //     warningAlert("Duplicate found, update not applied");
    //   }
    // }
  };
  const mergeArray = (arr) => {
    return arr.reduce((acc, val) => {
      const ind = acc.findIndex((item) => item.surgeryId === val.surgeryId);
      if (ind !== -1) {
        console.log("Service Already Exists");
      } else {
        acc.push(val);
      }
      return acc;
    }, []);
  };
  return (
    <div>
      <div className="flex justify-between bg-[#FFE6C9] rounded-t-md">
        <p className="text-sm font-semibold pl-2 py-1">Procedure</p>
        {/* <div className="flex my-auto">
          <button
            type="button"
            onClick={() => {
              setOpenSurgeryModal(true);
            }}
          >
            <div className="flex justify-between border w-36 mx-2 bg-white">
              <p className="text-xs my-auto px-2">Procedure</p>
              <SearchIcon />
            </div>
          </button>
        </div> */}
      </div>
      <div className="p-2   border pb-2 border-b-[#D9D9D9] border-r-[#D9D9D9] border-l-[#D9D9D9] bg-white rounded-b-md">
        {/* <div className="flex justify-between ">
          <div className="flex flex-wrap space-x-2 pl-2">
            {surgeryChipsList &&
              surgeryChipsList.slice(0, chipsCount).map((item, index) => {
                return (
                  <>
          
                    <button
                      type="button"
                      key={index}
                      className={`mr-[5px] mb-1 capitalize h-[27px] px-3 w-max rounded text-sm border border-gray-300 whitespace-nowrap ${
                        surgeryData?.some((val) => val?.surgery === item.label)
                          ? "bg-[#32819b] text-white rounded-full border"
                          : "text-black rounded-full border"
                      }`}
                    
                      onClick={() => {
                      
                        setSelectedChips([...selectedChips, item]);
                        setSelectedSurgery(item);
                        setOpenSurgeryModal(true);
                      }}
                    >
                      {item.value}
                    </button>
                  </>
                );
              })}
          </div>
        </div>

        {checkDuplicate === true ? (
          <p className="text-xs text-red-500"> Record Already Present</p>
        ) : (
          ""
        )} */}
        <div className="flex space-x-2 my-2">
          <div className="w-[40%] ">
            <SearchDropdown
              // ref={selectRef}
              focused={true}
              control={control}
              // error={errors.allergyType}
              name="surgeryName"
              label="Surgery "
              placeholder="Procedure"
              // dataArray={allergiesTypeList}
              isSearchable={false}
              dataArray={surgeryNameList}
              handleInputChange={handleChange}
              inputRef={{
                ...register(`surgeryName`, {
                  onChange: (e) => {
                    // handleCheckDuplicate();
                  },
                }),
              }}
              autoFocus
            />
          </div>

          <div className="w-[40%] flex space-x-2">
            <DropdownField
              name="surgeon"
              variant="outlined"
              placeholder="Doctor"
              control={control}
              dataArray={surgeonList}
              isSearchable={false}
              isClearable={false}
              // handleChange={handleChange}
              inputRef={{
                ...register(`surgeon`),
              }}
            />
          </div>

          <div className="">
            <CommonButton
              label="Add"
              type="button"
              onClick={() => {
                handleSubmitSurgery();
                // setSaveData(true);
              }}
              className="addButton bg-customBlue text-white"
            />

          </div>
        </div>
        <div className="h-44 overflow-auto">
          {" "}
          {surgeryData?.length > 0 ? (
            <CommonTransactionTable
              dataResult={mergeArray(surgeryData).map((row) => ({
                Surgery: row.surgery,
                Surgeon: row.surgeon,
                surgeonId: row.surgeonId,
                surgeryId: row?.surgeryId,
              }))}
              renderActions={renderAction}
              removeHeaders={["surgeonId", "surgeryId"]}
              highlightRow={false}
            />
          ) : null}
        </div>

        {/* <div className="">
          <OPDSurgeryModal
            surgeryData={surgeryData}
            setSurgeryData={setSurgeryData}
            dataSurgery={dataSurgery}
            setDataSurgery={setDataSurgery}
            openSurgeryModal={
              openSurgeryModal === true ? openSurgeryModal : editOpen
            }
            setOpenSurgeryModal={setOpenSurgeryModal}
            allSurgeryChipsList={allSurgeryChipsList}
            selectedSurgery={selectedSurgery}
            // selectedAllergieDecription={selectedAllergieDecription}

            setSelectedChips={setSelectedChips}
            selectedChips={selectedChips}
            data={data}
            setData={setData}
            setEditOpen={setEditOpen}
            edit={edit}
            setEdit={setEdit}
            row={row}
            index={index}
            setSave={setSave}
            patientVisitedDepartmentId={props.patientVisitedDepartmentId}
          />
        </div> */}
      </div>
    </div>
  );
}
